import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCakeCandles } from '@fortawesome/free-solid-svg-icons';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import AgeOptionList from './AgeOptionList';
/**
* Multi-select dropdown for age groups. Each age is an individual year - the
* user combines ages (e.g. 10 and 11) simply by selecting more than one.
*/
const AgeGroupMultiSelect = ({ options, selected, onChange, disabled, lockedAge, maxSelected, triggerLabel, icon }) => {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, open, () => setOpen(false));
    const label = triggerLabel
        ?? (selected.length === 0
            ? 'Select age'
            : options.filter(o => selected.includes(o.age)).map(o => o.displayAge).join(', '));
    return (React.createElement("div", { className: "rankings-county-filter age-multiselect", ref: wrapperRef },
        React.createElement(FontAwesomeIcon, { icon: icon ?? faCakeCandles, className: "rankings-county-icon" }),
        React.createElement("button", { type: "button", className: "age-multiselect-trigger", onClick: () => setOpen(o => !o), disabled: disabled, "aria-haspopup": "listbox", "aria-expanded": open, "aria-label": "Age groups", title: label },
            React.createElement("span", { className: "age-multiselect-label" }, label)),
        open && (React.createElement("div", { className: "age-multiselect-popover", role: "listbox", "aria-multiselectable": "true" },
            React.createElement(AgeOptionList, { options: options, selected: selected, onChange: onChange, lockedAge: lockedAge, maxSelected: maxSelected })))));
};
export default AgeGroupMultiSelect;
